import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { cn } from "../../libs/utils";

const QRCodePreview = ({
  value,
  displayValue,
  label,
  size = 72,
  className,
  showValue = false,
}) => {
  const qrValue =
    value === null || value === undefined || value === "" ? "" : String(value);

  const visibleValue = displayValue || qrValue;

  if (!qrValue) {
    return <span className="text-sm text-slate-400">-</span>;
  }

  return (
    <div className={cn("inline-flex flex-col items-center gap-2", className)}>
      <div className="rounded-md bg-white p-1.5 shadow-sm ring-1 ring-slate-100">
        <QRCodeSVG
          value={qrValue}
          size={size}
          level="M"
          bgColor="#ffffff"
          fgColor="#0f172a"
          marginSize={1}
          title={label ? `${label} QR code` : "QR code"}
        />
      </div>
      {showValue && (
        <span className="max-w-full break-all text-center text-xs font-medium text-slate-600">
          {visibleValue}
        </span>
      )}
    </div>
  );
};

export default QRCodePreview;
